import { localeStore } from './locale-store';
import type { TranslationValues } from './translate';
import { translate } from './translate';

/** Singular or plural key by `count` (exposed as `{count}`), outside components. */
export function tn(count: number, one: string, other: string, values?: TranslationValues): string {
  return translate(localeStore.read(), count === 1 ? one : other, { count, ...values });
}
